"use client";

import styled from "styled-components";

export const TableWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1rem;

  &.is-hidden-table-true {
    display: none;
  }

  .is-hidden-row-true {
    display: none;
  }

  .article-detail-mobile-ui-true & {
    gap: 0.8rem;

    .modality-icon-background {
      width: 2.4rem;
      height: 2.4rem;
    }
  }

  @media only screen and (max-width: 768px) {
    gap: 0.8rem;

    .modality-icon-background {
      width: 2.4rem;
      height: 2.4rem;
    }
  }
`;
